import { React, useEffect } from "react";
import CardLayout from "../../../components/ReusableComponents/CardLayout";
import DoughnutChart from "../../../components/ReusableComponents/DoughnutChart";
import { ChartCardContent } from "../../dashboard/dashboard.styled";
import { CardWrapper } from "../Logistics.styled";
import { toast } from "react-toastify";
import { fetchChartData } from "../utils";
import ChartlabelALT from "../../../components/ReusableComponents/ChartlabelALT";
import {
	DoughnutChartOptions,
	CustomDoughnutOptions,
} from "../../../Constants";
import { useDispatch, useSelector } from "react-redux";
import { setDeliveryChart } from "../LogisticSlice";

function DeployedChart() {
	const chartInfo = useSelector((state) => state.logistics.deliveryChart.info);
	const totalValue = useSelector(
		(state) => state.logistics.deliveryChart.totalValue
	);
	const dispatch = useDispatch();

	const chart1Data = {
		labels: ["successful", "delayed", "not delivered"],
		datasets: [
			{
				label: "requests",
				data: [chartInfo.successful, chartInfo.delayed, chartInfo.not_Delivered],
				backgroundColor: ["#006770", "#31D98C", "#FF7878"],
			},
		],
		totalValue: totalValue.chart1,
	};

	const chart2Data = {
		labels: ["Door step", "Pick up"],
		datasets: [
			{
				label: "orders",
				data: [chartInfo.door_step, chartInfo.pick_up],
				backgroundColor: ["#83D695", "#CDCDCD"],
			},
		],
		totalValue: totalValue.chart2,
	};

	useEffect(() => {
		getChartData();
	}, []);

	const getChartData = async () => {
		try {
			const chartInfo = await fetchChartData('deployedAnalysis');
			if (chartInfo?.result) {
				let result = {
					info: {
						successful: chartInfo.result?.successful,
						delayed: chartInfo.result?.delayed,
						not_Delivered: chartInfo.result?.not_Delivered,
                        door_step: chartInfo.result?.door_step,
                        pick_up: chartInfo.result?.pick_up,
					},
					totalValue: {
						chart1: chartInfo.result?.successful + chartInfo.result?.delayed + chartInfo.result?.not_Delivered,
						chart2: chartInfo.result?.door_step + chartInfo.result?.pick_up,
					},
				};
				dispatch(setDeliveryChart(result));
			}
		} catch (error) {
			console.error(error);
			toast.error("unable to fetch chart data");
		}
	};
	return (
		<CardWrapper>
			<CardLayout type='Delivery performance'>
				<ChartCardContent firstcolor='#83D695' secondcolor='#CDCDCD'>
					<DoughnutChart
						totalAmount={totalValue.chart1}
						data={chart1Data}
						options={CustomDoughnutOptions}
					/>
					<ChartlabelALT
						firstColorId={"#006770"}
						firstCaption={"Successful"}
						firstAmount={chartInfo?.successful}
						secondColorId={"#31D98C"}
						secondCaption={"Delayed"}
						secondAmount={chartInfo?.delayed}
						thirdColorId={"#FF7878"}
						thirdCaption={"Not delivered"}
						thirdAmount={chartInfo?.not_Delivered}
						totalAmount={totalValue.chart1}
						customLabel={"request(s)"}
					/>
				</ChartCardContent>
			</CardLayout>

			<CardLayout type='Delivery method'>
				<ChartCardContent firstcolor='#83D695' secondcolor='#CDCDCD'>
					<DoughnutChart
						totalAmount={totalValue.chart2}
						data={chart2Data}
						options={DoughnutChartOptions}
					/>
					<ChartlabelALT
						firstColorId={"#83D695"}
						firstCaption={"Door step"}
						firstAmount={chartInfo?.door_step}
						secondColorId={"#CDCDCD"}
						secondCaption={"Pick up"}
						secondAmount={chartInfo?.pick_up}
						totalAmount={totalValue.chart2}
						customLabel={"orders"}
					/>
				</ChartCardContent>
			</CardLayout>
		</CardWrapper>
	);
}

export default DeployedChart;
